import React from "react";
import { Star, Quote } from "lucide-react";
import { reviews, reviewsImage } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Reviews() {
  const ref = useReveal();
  return (
    <section id="reviews" ref={ref} className="bg-[#f6f8fc] py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-14 cc-reveal">
          <h2 className="font-head text-3xl md:text-4xl font-bold text-[#16244F]">Students&rsquo; Reviews</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-[#F58220]" />
          <p className="max-w-3xl mx-auto mt-6 text-[#5a6274]">
            Students highlight significant support in gaining self-awareness, exploring options, and developing
            essential skills for career success &mdash; often leading to informed decision-making and real confidence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {reviews.map((r, i) => (
            <div
              key={r.name}
              className="cc-reveal bg-white rounded-2xl p-7 cc-shadow-card relative hover:-translate-y-1 transition-transform duration-300"
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <Quote className="text-[#eaf3ff]" size={54} />
              <p className="-mt-6 text-[15px] leading-relaxed text-[#45506b] italic">&ldquo;{r.text}&rdquo;</p>
              <div className="flex gap-1 mt-5">
                {Array.from({ length: r.rating }).map((_, k) => (
                  <Star key={k} size={18} className="fill-[#F58220] text-[#F58220]" />
                ))}
              </div>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-11 h-11 rounded-full bg-[#16244F] text-white flex items-center justify-center font-head font-semibold">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <div className="font-head font-semibold text-[#16244F]">{r.name}</div>
                  <div className="text-sm text-[#8a90a0]">{r.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
